// React
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Data
import { configConst } from 'OMFECore/config-manager';
import { DataManager, dataConst } from 'OMFECore/data-manager';
import filterProps from 'SharedComponents/filterProps';

// Components
import uuidWrapper from 'SharedComponents/uuidWrapper';
import OddsBannerCarousel from './components/OddsBannerCarousel';
import OMFEOddsBanner from './OMFEOddsBanner';

const absoluteUrlRegex = /^(https?:)?\/\//;

@connect(
        (store, props) => ({
            slides:
            store &&
            store[dataConst.STORE_PART] &&
            store[dataConst.STORE_PART][props.uuid] &&
            store[dataConst.STORE_PART][props.uuid].slides,
            providerId:
            store &&
            store[configConst.STORE_PART] &&
            store[configConst.STORE_PART].operatorInfo &&
            store[configConst.STORE_PART].operatorInfo.providerId,
            operatorId:
            store &&
            store[configConst.STORE_PART] &&
            store[configConst.STORE_PART].operatorInfo &&
            store[configConst.STORE_PART].operatorInfo.operatorId,

            ucsOperatorId:
            store &&
            store[configConst.STORE_PART] &&
            store[configConst.STORE_PART].operatorInfo &&
            store[configConst.STORE_PART].operatorInfo.ucsOperatorId,

            apiVersion:
            store &&
            store[configConst.STORE_PART] &&
            store[configConst.STORE_PART].operatorInfo &&
            store[configConst.STORE_PART].operatorInfo.apiVersion,

            defaultLanguage:
            store &&
            store[configConst.STORE_PART] &&
            store[configConst.STORE_PART].language,
        }),
        dispatch => bindActionCreators({}, dispatch)
)
    /**
     * Data provisioning wrapper around multi-match OddsBanner via a carousel-like system
     */
class OMFEOddsBannerCarousel extends Component {

    static propTypes = {

        ucsOperatorId: PropTypes.any,
        apiVersion: PropTypes.any,

        /** Function to call when current match id changes, signature is (matchId) */
        onChange: PropTypes.func,

        /** Language */
        language: PropTypes.string,

        /** Use matches from a specific tournament instead of slides */
        tournamentId: PropTypes.any,

        /** The host from where the relative image URLs are fetched from */
        baseHost: PropTypes.string,

        /* Everything else */
        slides: PropTypes.any,
        children: PropTypes.node,
        className: PropTypes.string,
        style: PropTypes.any,
        id: PropTypes.any,

        uuid: PropTypes.any,
        operatorId: PropTypes.any,
        providerId: PropTypes.any,
        defaultLanguage: PropTypes.any,
        subscribeToOddsBannerData: PropTypes.func,
        unsubscribeFromOddsBannerData: PropTypes.func,
        requestOddsBannerTournamentMatches: PropTypes.func,

        deleteStorePart: PropTypes.func,
    };

    // Widget Config Options
    static defaultProps = {
        onChange: matchId => matchId,
        baseHost: 'https://static.glastcoper.com',
    };

    componentWillMount(){
        this.propSets = this.getPropSets(this.props.slides, this.props);

        this.dm = new DataManager(this.props.uuid);

        this.resubscribe(this.props);
    }

    componentWillUpdate(nextProps){
        this.resubscribe(nextProps);

        // propSets update
        for (const key of [].concat(Object.keys(this.props)).concat(Object.keys(nextProps))){
            if (this.props[key] !== nextProps[key]){
                this.propSets = this.getPropSets(nextProps.slides, nextProps);
                break;
            }
        }
    }

    componentWillUnmount(){
        this.dm.unsub('slides', 'unsubscribeFromOddsBannerData');
        this.dm.done();
    }

    getSlideImageUrl(slide) {
        const {baseHost} = this.props;

        if (absoluteUrlRegex.test(slide.imageUrl)) {
            return slide.imageUrl;
        }

        let imagePath = slide.imageUrl;

        if (imagePath[0] === '/') {
            imagePath = imagePath.substr(1);
        }

        return `${baseHost}/${imagePath}`;
    }

    getPropSets(slides = {}, props = {}){
        const {...restProps} = props;
        delete restProps.className;
        delete restProps.style;
        delete restProps.id;
        delete restProps.baseHost;
        const filteredRestProps = filterProps(restProps, this.constructor.propTypes);
        const sortedSlides = slides && slides[0] && slides || [];
        if (sortedSlides){
            sortedSlides.sort((a, b) => b.priorityOrder - a.priorityOrder || a - b);
        }

        return !sortedSlides && [] || sortedSlides.filter(slide => slide.matchId || slide.imageUrl).map(slide => ({
            ...filteredRestProps,
            matchId: slide.matchId,
            backgroundImage: this.getSlideImageUrl(slide),
            backgroundUrl: slide.backgroundUrl || null,
        }));
    }

    resubscribe({ucsOperatorId, apiVersion, defaultLanguage, language, operatorId, uuid}){
        const lang = language || defaultLanguage || 'en';

        // resubscribe to match
        if (
                ucsOperatorId !== this.ucsOperatorId ||
                apiVersion !== this.apiVersion ||
                lang !== this.lang ||
                operatorId !== this.operatorId
        ){
            this.dm.unsub('slides', 'unsubscribeFromOddsBannerData');
            if (lang && (operatorId || ucsOperatorId)){
                this.dm.sub('slides', 'subscribeToOddsBannerData', {ucsOperatorId, apiVersion, lang, operatorId, uuid});
            }

            this.lang = lang;
            this.operatorId = operatorId;
            this.ucsOperatorId = ucsOperatorId;
            this.apiVersion = apiVersion;
        }
    }

    render(){
        const {className, style, id, onChange, ...restProps} = this.props;

        if (!this.propSets || !this.propSets.length){
            return null;
        }

        const newProps = {
            component: OMFEOddsBanner,
            uniqueKey: 'id',
            propSets: this.propSets,
            className,
            style,
            id,
            onChange: (propSet) => propSet && propSet.matchId && onChange(propSet.matchId),
            ...filterProps(restProps, this.constructor.propTypes),
        };

        return (
                <OddsBannerCarousel {...newProps}>
                    {this.props.children}
                </OddsBannerCarousel>
        );
    }
}

export default uuidWrapper(OMFEOddsBannerCarousel);




// WEBPACK FOOTER //
// ./src/OMFEOddsBanner/OMFEOddsBannerCarousel.js